<app-sub-header
  pageTitle="Home"
  [showHistoryToggle]="false"
  [showRagIcon]="false"
  [showAudioIcon]="false"
/>
<div class="home-wrapper ms-4 mt-4">
  <h1 class="visually-hidden">
    ROWS Rail Operation Weather Service
  </h1>
  <img
    [src]="imagePath"
    alt="ROWS Rail Operation Weather Service"
    class="heading-image mt-3 w-100"
  />
  <div>
    <div class="mb-5 mt-5 d-flex">
      <current-features></current-features>
    </div>

    <div class="mb-5 d-flex">
      <div class="px-2 w-100">
        <future-releases></future-releases>
      </div>
    </div>
  </div>
</div>
